export const basicPasswordOptions = {
  required: {
    value: true,
    message: "Bitte wählen Sie ein Passwort.",
  },
  minLength: {
    value: 14,
    message:
      "Bitte wählen Sie ein Passwort mit einer Mindestlänge von 14 Zeichen.",
  },
  maxLength: {
    value: 64,
    message:
      "Bitte wählen Sie ein Passwort mit einer Höchstlänge von 64 Zeichen.",
  },
  pattern: {
    value: /^(?!.*\s)(?=.*[0-9])(?=.*[a-zäöüß])(?=.*[A-ZÄÖÜ])(?=.*[~!@#$%^&*()\-_=+[{}\]|;:'",<.>/?€£¥₹§±]).*$/, // NOSONAR
    message:
      "Bitte beachten Sie die Passwortanforderungen. Zulässige Sonderzeichen: ~!@#$%^&*()-_=+[{}]|;:'\",<.>/?€£¥₹§±",
  },
};

export const basicEmailOptions = {
  required: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
  minLength: {
    value: 8,
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
  maxLength: {
    value: 60,
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
  pattern: {
    value:
    // eslint-disable-next-line max-len
      /^[a-zA-Z0-9!#$%&’*+=?^_`{|}~-]+(.?[a-zA-Z0-9!#$%&’*+=?^_`{|}~-])+@{1}[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/, // NOSONAR
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
};

export const customerSecurityTypes = [
  // caution: don't change the order! only append new types!
  "email_domain",
  "email_domain_suffix",
  "ip_address",
  "ip_email", // combines ip_address & email_domain
  "ip_email_suffix", // combines ip_address & email_domain_suffix
];

export const basicEmailOptionsSecurityType0 = {
  required: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
  minLength: {
    value: 2,
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
  pattern: {
    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*))$/,
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
};

export const basicEmailOptionsSecurityType1 = [
  {
    required: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
    minLength: {
      value: 2,
      message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    },
    pattern: {
      value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*))$/,
      message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    },
  },
  {
    required: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
    minLength: {
      value: 1,
      message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    },
    pattern: {
      value: /^(?![-.])[a-zA-Z0-9.-]+(?<![-.])$/,
      message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    },
  }
];

export const basicEmailOptionsSecurityType2 = {
  required: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
  minLength: {
    value: 8,
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
  maxLength: {
    value: 60,
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
  pattern: {
    value:
    // eslint-disable-next-line max-len
      /^[a-zA-Z0-9!#$%&’*+=?^_`{|}~-]+(.?[a-zA-Z0-9!#$%&’*+=?^_`{|}~-])+@{1}[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/, // NOSONAR
    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
};
